module.exports = __webpack_public_path__ + "static/media/icon.180c2f48.png";